import request from '@/common/request'

export default {
    /**
     * 根据设备id 获取锁列表
     *
     * @param deviceId 设备id
     * @return 列表结果
     */
    getLocksByDeviceId: (orgCode,data) => {
        return request({
            url: `/v1/lockManage/getTaskLocks/${orgCode}`,
            method: 'post',
            data
        })
    },
    /**
     *  create 增
     *  delete 删
     *  update 改
     *  query  查
     */
    createLockManage: (data) => {
        return request({
            url: '/v1/lockManage',
            method: 'post',
            data,
        })
    },
    deleteLockManage: (dynaSeg, data, params) => {
        return request({
            url: `/v1/lockManage/${dynaSeg.id}`,
            method: 'delete',
            data,
            params
        })
    },
    updateLockManage: (dynaSeg, data, params) => {
        return request({
            url: `/v1/lockManage/${dynaSeg.id}`,
            method: 'put',
            data,
            params
        })
    },
    queryLockManage: (params) => {
        return request({
            url: '/v1/lockManage',
            method: 'get',
            params
        })
    },
    // 上缴
    turnInLock: (params,data) => {
        return request({
            url: `/v1/lockManage/turnInLock?lockId=${params.lockId}`,
            method: 'post',
            data
        })
    },
    // 应急码
    getLockRandomCode: (params) => {
        return request({
            url: '/v1/lockManage/getLockRandomCode',
            method: 'get',
            params
        })
    },
    // 根据设备id数组 获取设备名称
    getDeviceIdList: (data) => {
      return request({
          url: '/deviceInfo/getDeviceByIds',
          method: 'post',
          data
      })
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/lockManage.js